import { create } from "zustand";
import { persist } from "zustand/middleware";
import { type MRT_SortingState } from "material-react-table";

interface TableState {
  columnVisibility: Record<string, boolean>;
  sorting: MRT_SortingState;
  setColumnVisibility: (v: Record<string, boolean>) => void;
  setSorting: (s: MRT_SortingState) => void;
  reset: () => void;
}

export const useTableState = create<TableState>()(
  persist(
    (set) => ({
      columnVisibility: {},
      sorting: [],
      setColumnVisibility: (v) => set({ columnVisibility: v }),
      setSorting: (s) => set({ sorting: s }),
      reset: () => set({ columnVisibility: {}, sorting: [] }),
    }),
    {
      name: "table-state-storage",
    }
  )
);
